import { API_BASE } from "@/lib/utils";

export function bumpEventFunnel(eventId, step) {
  const id = String(eventId || "").trim();
  const s = String(step || "").trim();
  if (!id || !s || typeof fetch === "undefined") return;
  fetch(`${API_BASE}/api/public/funnel`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ eventId: id, step: s }),
    keepalive: true,
  }).catch(() => {});
}
